


import { z } from "zod";
import { License } from "../License";
import type { AssertSchemaMatchesClass } from "../../../utils/typeUtils";

const _LicenseZod = z.object({
  impactPlusReportCredits: z.number().optional().default(0),
  impactPlusReportRefreshCredits: z.number().optional().default(0),
  riskPlusReportCredits: z.number().optional().default(0),
  riskPlusReportRefreshCredits: z.number().optional().default(0),
  controlPlusReportCredits: z.number().optional().default(0),
  controlPlusReportRefreshCredits: z.number().optional().default(0),
  platformAccessUntil: z.string().optional().default(""),
  licenseTier: z.string().optional().default(""),
})

// Assert that schema matches the class definition
void (true as AssertSchemaMatchesClass<typeof _LicenseZod, License>);
export const LicenseSchema = _LicenseZod.transform((data) => new License(data));






